import Vue from 'vue';
import { Module, Commit } from 'vuex/types';
import firebase from '@/plugins/firebase';

// let _functions: firebase.functions.Functions;
// function functions(): firebase.functions.Functions {
// 	// if (!_functions){
// 	// 	_functions = firebase.app().functions('europe-west1');
// 	// }
// 	return _functions;
// }

export interface User {
  email?: string,
  emailVerified?: boolean,
  phoneNumber?: string,
	isAnonymous?: boolean,
	uid: string,
	ios?: boolean,
	android?: boolean,
  farmersWifeUser?: string,
  subscribed: boolean,
}
interface Users {
	[key: string] : User | any,
}
interface State {
	all: Users,
}

const subscribe = function (commit: Commit, state: any, uid: string) {
  return new Promise((resolve, reject) => {
    	if (state[uid] && state[uid].subscribed) {
    		resolve(state[uid]);
    	} else {
  			firebase.firestore().collection('users').doc(uid).onSnapshot((snapshot) => {
  				commit('insertOrUpdate', { ...snapshot.data(), uid, subscribed: true });
  				resolve(state[uid]);
  			}, error => console.error(error));
    	}
  });
};
const module: Module<State, any> = {
  namespaced: true,
  state: {
  	all: {},
  },
  mutations: {
  	insertOrUpdate(state: any, data: any) {
      data = JSON.parse(JSON.stringify(data));
      if (!data) {
        return;
      }
  		if (state.all[data.uid]) {
  			for (const key of Object.keys(data)) {
  				Vue.set(state.all[data.uid], key, data[key]);
  			}
  			return state.all[data.uid];
  		}
  			Vue.set(state.all, data.uid, data);
  			return state.all[data.uid];
  	},
  	delete(state: any, uid: string) {
  		// Probably not reactive
  		Vue.delete(state.all, uid);
  	},
  },
  actions: {
  	fetch({
      commit, state, getters, dispatch,
    }, uid: string) {
      console.log(`Fetch ${uid}`);
	    return new Promise((resolve, reject) => {
	    	if (!state.all[uid]) {
	    		commit('insertOrUpdate', { uid });
	    	}
        subscribe(commit, state, uid).then(question => resolve(question)).catch(error => reject(error));
	    	resolve(state.all[uid]);
	    });
    },
    store({
      commit, state, getters, dispatch,
    }, user: User) {
      return new Promise((resolve, reject) => {
        firebase.firestore().collection('users').doc(user.uid).update(user)
          .then(() => {
            resolve();
          })
          .catch(error => reject(error));
      });
    },
    storeWriteOnly({
      commit, state, getters, dispatch,
    }, { user_uid, docName, data } : {user_uid: string, docName: string, data: Object}) {
      return new Promise((resolve, reject) => {
        firebase.firestore().collection('users').doc(user_uid).collection('write-only')
          .doc(docName)
          .set(data)
          .then(() => {
            resolve();
          })
          .catch(error => reject(error));
      });
    },
    deleteWriteOnly({
      commit, state, getters, dispatch,
    }, { user_uid, docName } : {user_uid: string, docName: string}) {
      return new Promise((resolve, reject) => {
        firebase.firestore().collection('users').doc(user_uid).collection('write-only')
          .doc(docName)
          .delete()
          .then(() => {
            resolve();
          })
          .catch(error => reject(error));
      });
    },
  },
};

export default module;
